const colors = {
    primary: "#3a3aff",
    error: "#e94949",
    secondary: "#000",
    success: "#32b081",
    warning: "#FF9632",
    light: "#FFFFFF"
};

export default colors;
